/**
 * cn — shadcn's canonical "merge tailwind classes" helper. Port from
 * frontend/src/lib/utils.ts (verbatim).
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
